import * as React from 'react';
import {StatelessComponent} from 'react';
import './styles.sass';

interface IForgotPasswordAlertProps {
  email?: string;
  onClick?: (e?: any) => void;
}

export const ForgotPasswordAlert: StatelessComponent<IForgotPasswordAlertProps> = ({
  email,
  onClick,
}) => (
  <div className={'forgot-password-alert'}>
    <div className={'forgot-password-alert__header'}>Please Check Your Mailbox.</div>
    <div className={'forgot-password-alert__text'}>We've sent a password reset link to</div>
    <div className={'forgot-password-alert__email'}>{email}</div>
    <div className={'forgot-password-alert__text forgot-password-alert__text_top-blank'}>
      <a className={'forgot-password-alert__send-again'} href={'#'} onClick={onClick}>Send again</a>
    </div>
  </div>
);
